module.exports = __webpack_public_path__ + "img/login_bg.b7aa5129.jpg";